<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/building/topic_icon.svg" />
      <h1>Building Facilities</h1>
      <p>
        Safely manage buildings that many people frequent to protect
        <br />
        against pests and viruses.
      </p>
      <div class="topic-tags">
        <span class="tag"> #Offices </span>
        <span class="tag"> #Co-working Spaces </span>
        <span class="tag"> #Commercial Buildings </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img
      :src="require(`@/assets/images/location/building/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [BusinessSectors] Building Facilities"
    />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_response.svg" alt="CESCO [BusinessSectors] Building Facilities" />
            <div class="title">
              <h3>Professional Claim Response</h3>
            </div>
            <p class="description">I want to eliminate anxiety about unexpected pests while maintaining a clean store image.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_prevent.svg" alt="CESCO [BusinessSectors] Building Facilities" />
            <div class="title">
              <h3>Virus Transmission Management</h3>
            </div>
            <p class="description">
              I am concerned about preventing potential cross-contamination and managing access by COVID-19 positive individuals.
            </p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="CESCO [BusinessSectors] Building Facilities" />
            <div class="title">
              <h3>Professional Disinfection</h3>
            </div>
            <p class="description">I am concerned about disinfection management due to public access.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Address concerns about virus transmission in enclosed spaces with CESCO.</h4>
            <p>
              Areas like elevators and meeting rooms, frequented by many people, need thorough virus management. CESCO ensures 24-hour safety by
              monitoring air quality and managing viruses through 1:1 customized consultations.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/building/border_content_01.png" alt="CESCO [BusinessSectors] Building Facilities" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="CESCO [BusinessSectors] Building Facilities" />
          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="CESCO [BusinessSectors] Building Facilities" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Building Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="CESCO [BusinessSectors] Building Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_fly.svg" alt="CESCO [BusinessSectors] Building Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Flying Pest Control Solution</h3>
              </div>
              <p class="description">Managing stray pests such as flies, fruit flies, and sandflies</p>
            </div>

            <router-link to="/solution/service/fly"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="CESCO [BusinessSectors] Building Facilities" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>

            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/building/background_img_01.png'),
    products: [
      {
        posX: '47.4375rem',
        posY: '22.495rem',
        mobilePosX: '63%',
        mobilePosY: '70%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      },
      {
        posX: '63rem',
        posY: '7.245rem',
        mobilePosX: '83%',
        mobilePosY: '22%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_02.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/building/background_img_02.png'),
    products: [
      {
        posX: '36.6875rem',
        posY: '23.37rem',
        mobilePosX: '49%',
        mobilePosY: '62%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_03.png'),
          name: 'CESCO\nWater Smart-Fit Direct Water Purifier',
          description: 'Enhance your kitchen with a water purifier available in eight colors tailored to your personal taste.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/building/background_img_03.png'),
    products: [
      {
        posX: '21.75rem',
        posY: '19.245rem',
        mobilePosX: '31%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_04.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      },
      {
        posX: '45.875rem',
        posY: '23.495rem',
        mobilePosX: '61.5%',
        mobilePosY: '67%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_05.png'),
          name: 'CESCO\nAir IOT Air Purifier SE',
          description: 'Manage air quality intelligently with options customized for your business environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/building/background_img_04.png'),
    products: [
      {
        posX: '37.5rem',
        posY: '7.0575rem',
        mobilePosX: '51%',
        mobilePosY: '22%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      },
      {
        posX: '43.4375rem',
        posY: '18.495rem',
        mobilePosX: '64%',
        mobilePosY: '50%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_06.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Hand Gienic',
          description: 'This non-contact foam type eliminates 99.9% of harmful bacteria on hands.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/building/background_img_05.png'),
    products: [
      {
        posX: '51rem',
        posY: '9.62rem',
        mobilePosX: '67.5%',
        mobilePosY: '30%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_07.png'),
          name: 'CESCO\nAirgenic',
          description: 'This automatic air freshener and deodorizer boasts powerful odor neutralization and fragrance release.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/building/background_img_06.png'),
    products: [
      {
        posX: '47.8125rem',
        posY: '12.495rem',
        mobilePosX: '65%',
        mobilePosY: '35%',
        productInfo: {
          image: require('@/assets/images/location/building/product_img_09.png'),
          name: 'CESCO\nAutomatic Toilet Cleaning Sterilizer Freshgenic',
          description: 'Cleans the toilet automatically by sterilizing 99.9% of harmful bacteria and removing 99.9% of odor-causing gases.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}

useMeta({
  title: 'CESCO - Building Facilities',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Building Facilities. Safely manage buildings that many people frequent to protect against pests and viruses.'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
